import {useEffect, useState} from "react";
import {gql, useSubscription} from "@apollo/client";
import {useKeycloak} from "../src/useKeycloak";
import {useVisibility} from "./useVisibility";
import ToastComponent from "../components/ToastComponent";
import toast from "react-hot-toast";
import {useRouter} from "next/router";
import {getNavigateUrl} from "../components/Notification/utils";

const SUB_NOTIFICATIONS_STREAM = gql`
subscription NotificationSubscription($timeFrom: timestamptz = "", $userId: uuid = "") {
  notificationSendsStream(batchSize: 1, cursor: {initialValue: {createdAt: $timeFrom}}, where: {userIdTo: {_eq: $userId}}) {
  	id
    title
    body
    doNavigateParams
    doNavigateScreen
    doNavigateStack
    createdAt
    category
    priority
    push
    seen    
  }
}
`;

/* mulige kategorier pr 19 feb 2025
 den vil komme inn
* "data":
    "notificationSendsStream":
        "category": "phone_cc_pre_call"
*/
const categoryType = [
	"phone_register",
	"phone_register_post_call",
	"phone_register_post_call_privatized",
	"phone_register_pre_call",
	"phone_cc_logging",
	"phone_test",
	"phone_cc_pre_call",
	"phone_cc_post_call",
	"phone_emp_pre_call",
	"phone_emp_post_call",
	"phone_register_lost_call",
	"phone_register_lost_call_outgoing",
	"notLocal_phone_register_lost_call",
	"notLocal_phone_register_lost_call_outgoing",
	"phone_cc_lost_call",
	"phone_cc_lost_call_outgoing",
	"phone_emp_lost_call",
	"phone_emp_lost_call_outgoing",
	"reminder"
];


export const useNotifyer = () => {
	const {tokenParsed} = useKeycloak();
	const router = useRouter();
	const {visible} = useVisibility();
	const [currentDate, setCurrentDate] = useState(new Date());

	const excludeCategories = [
		"phone_register_lost_call",
		"phone_register_lost_call_outgoing",
		"notLocal_phone_register_lost_call",
		"notLocal_phone_register_lost_call_outgoing",
		"phone_cc_lost_call",
		"phone_cc_lost_call_outgoing",
		"phone_emp_lost_call",
		"phone_emp_lost_call_outgoing",
		"reminder"
	];


	const { data, error, loading} = useSubscription(SUB_NOTIFICATIONS_STREAM, {
		context: { headers: { "x-hasura-role": "operator" } },
		variables: {
			userId: tokenParsed?.sub,
			timeFrom: currentDate.toISOString()
		}
	});

	useEffect(() => {
		// console.log("new data: ", data);
		if (data?.notificationSendsStream?.length > 0) {
			// const url = "";
			const {title, body, doNavigateParams, category} = data?.notificationSendsStream[0];
			if (doNavigateParams !== undefined) {
				const {category: categoryDNP } = JSON.parse(doNavigateParams);
				// console.log("JSON.parse(doNavigateParams): ", JSON.parse(doNavigateParams));
				const isExcluded = excludeCategories.includes(category ?? categoryDNP);
				// if (isExcluded) console.log("Excluded category: ", category);

				if (!isExcluded) {
					const parsedParams = JSON.parse(doNavigateParams);
					const url = getNavigateUrl(parsedParams, category);
					setCurrentDate(new Date());
					if (visible) {
						console.log("Foreground Notification", data);
						toast((t) => <ToastComponent title={title} message={body} onNotificationClick={() => {
							console.log("onNotificationClickClick: ", url);
							router.push(url);
						}}/>, {duration: 10000});
					}
					else {
						console.log("Background Notification", data);
						const notification = new Notification(title, {body: body, icon: "/youtello_logo_white_64.png"});
						notification.onclick = () => {
							console.log("onNotificationClickClick: ", url);
							window.focus();
							router.push(url);
						};
					}
				}
			}
		}
	}, [data]);

	return [""];
};

/****** Notater ******/

/* Denne funksjonen er hentet i fra mobilkoden, og er en funksjon som henter ut knapper som skal vises i en notifikasjon.
export const getButtonsToAdd = (parameters) => {

if (parameters?.type === 'TELEPHONY') {
  if (parameters.category == 'phone_register') {
    //Ikke kunde, gammel
      t('Register customer'),
      t('Call back later'),
      t('Google'),
    });
  } else if (parameters.category == 'phone_register_post_call') {
    //Ikke kunde, etter samtale
      t('Customer call'),
      t('Private call'),
      t('Task'),
    });
  } else if (parameters.category == 'phone_register_post_call_privatized') {
    //Ikke kunde, etter samtale
      t('Remember to call'),
      t('Other task'),
    });
  } else if (parameters.category == 'phone_register_pre_call') {
    //Ikke kunde, før samtale
      t('Google'),
      t('Call back later'),
    });
  } else if (parameters.category == 'phone_cc_logging') {
    //Kunde, loggespørsmål
      t('OK'),
      t('Choose setting'),
    });
  } else if (parameters.category == 'phone_test') {
    //Bekreftelse, testsamtale
      t('Complete settings'),
    });
  } else if (parameters.category == 'phone_cc_pre_call') {
    //Kunde, før samtale
      t('Google'),
      t('Call back later'),
      t('Show customer card'),
    });
  } else if (parameters.category == 'phone_cc_post_call') {
    //Kunde, etter samtale
      t('Make note'),
      t('Remember to call'),
      t('Show customer card'),
    });
  } else if (parameters.category == 'phone_emp_pre_call') {
    //Ansatt, før samtale
      t('Direct message'),
      t('Call back later'),
      t('Other task'),
    });
  } else if (parameters.category == 'phone_emp_post_call') {
    //Ansatt, etter samtale
      t('Make note'),
      t('Remember to call'),
      t('Employee card'),
    });
  } else if (parameters.category == 'phone_register_lost_call') {
    //Ikke kunde, tapt/kort
      t('Call back now'),
      t('Remember to call back'), //Egentlig en callto
      t('Other task'),
    });
  } else if (parameters.category == 'phone_register_lost_call_outgoing') {
    //Ikke kunde, tapt/kort
      t('Call now'),
      t('Call later'), //Egentlig en callto
      t('Other task'),
    });
  } else if (parameters.category == 'notLocal_phone_register_lost_call') {
    //Ikke kunde, tapt/kort
      t('Google'),
      t('Remember to call back'), //Egentlig en callto
      t('Other task'),
    });
  } else if (parameters.category == 'notLocal_phone_register_lost_call_outgoing') {
    //Ikke kunde, ikke lokalt heller, tapt/kort
      t('Google'),
      t('Call now'),
      t('Call later'), //Egentlig en callto
    });
  } else if (parameters.category == 'phone_cc_lost_call') {
    //Kunde, tapt/kort
      t('Call back now'),
      t('Remember to call back'), //Egentlig en callto
      t('Other task'),
    });
  } else if (parameters.category == 'phone_cc_lost_call_outgoing') {
    //Kunde, tapt/kort
      t('Call now'),
      t('Call later'), //Egentlig en callto
      t('Other task'),
    });
  } else if (parameters.category == 'phone_emp_lost_call') {
    //Ansatt, tapt/kort
      t('Direct message'),
      t('Call back now'),
      t('Remember to call back'), //Egentlig en callto
    });
  } else if (parameters.category == 'phone_emp_lost_call_outgoing') {
    //Ansatt, tapt/kort
      t('Direct message'),
      t('Call now'),
      t('Call later'), //Egentlig en callto
    });
  } else {
      t('Open app'),
    });
  }
} else {
  //message osv
  if (parameters.mentionedId !== '') {
      t('Show customer card'),
      t('Show message'),
    });
  } else {
      t('Show message'),
  }
}
};
 */

/*{
	"id": "773b2200-5126-4d5d-8df2-14a220e35679",
	"type": "TELEPHONY",
	"customerId": "522d38da-4428-4279-bfcd-06d9c24c182a", // domainuser id , kan være orguserid om det finnes en orguser
	"customerPhone": "+4797787151",
	"category": "phone_register_pre_call",
	"messageNote": "",
	"messageNoteData": "",
	"lastContactMessage": "+4797787151\nVinterbroveien 27, 1407 Vinterbro\nSiste: Herman A. (01.11.24 8:52)",
	"customer": {
	"id": "522d38da-4428-4279-bfcd-06d9c24c182a",
		"category": "CUSTOMER_CANDIDATE",
		"firstName": "William Gunerius",
		"lastName": "Dalen",
		"phoneNumber": "+4797787151",
		"city": "Vinterbro",
		"street": "Vinterbroveien 27",
		"zip": "1407",
		"relOrganizationUser": [],
		"__typename": "domainUser"
},
	"customerFull": {
	"id": "522d38da-4428-4279-bfcd-06d9c24c182a",
		"category": "CUSTOMER_CANDIDATE",
		"firstName": "William Gunerius",
		"lastName": "Dalen",
		"phoneNumber": "+4797787151",
		"city": "Vinterbro",
		"street": "Vinterbroveien 27",
		"zip": "1407",
		"relOrganizationUser": [],
		"__typename": "domainUser"
},
	"timeCreated": "01.11.24 8:52"
}
*/
